import axiosInstance, { getNewCancelToken } from '@/services/_AxiosInstance';

/**
 * Service untuk mengelola Bunkering Log
 * @namespace BunkeringLogSvc
 */
export default {
  /**
   * Mendapatkan semua data Bunkering Log
   * @function getBunkeringLog
   * @return {Promise} Promise yang berisi response dari server
   */
  getBunkeringLog: async (params) => {
    const { data } = await axiosInstance.get('/master/bunker/log', {
      params: {
        ...params,
      },
      cancelToken: getNewCancelToken(),
    });
    return data;
  },
  /**
   * Mendapatkan data Bunkering Log berdasarkan periode
   * @function getBunkeringLogByPeriod
   * @param {number} unixStart - Unix timestamp mulai periode
   * @param {number} unixEnd - Unix timestamp akhir periode
   * @return {Promise} Promise yang berisi response dari server
   */
  getBunkeringLogByPeriod: async (unixStart, unixEnd, params) => {
    const { data } = await axiosInstance.get(`/master/bunker/log/period/${unixStart}/${unixEnd}`, {
      params: { ...params },
      cancelToken: getNewCancelToken(),
    });
    return data;
  },
  /**
   * Mendapatkan data Bunkering Log berdasarkan ID
   * @function getBunkeringLogById
   * @param {number} id - ID dari Bunkering Log yang ingin di dapatkan
   * @return {Promise} Promise yang berisi response dari server
   */
  getBunkeringLogById: async (id) => {
    const { data } = await axiosInstance.get(`/master/bunker/log/${id}`, {
      cancelToken: getNewCancelToken(),
    });
    return data;
  },
  /**
   * Membuat data Bunkering Log baru
   * @function createBunkeringLog
   * @param {object} data - Data yang ingin di buat
   * @return {Promise} Promise yang berisi response dari server
   */
  createBunkeringLog: async (bunkeringLogData) => {
    const { data } = await axiosInstance.post('/master/bunker/log', bunkeringLogData, {
      cancelToken: getNewCancelToken(),
    });
    return data;
  },
  /**
   * Mengupdate data Bunkering Log yang sudah ada
   * @function updateBunkeringLog
   * @param {number} id - ID dari Bunkering Log yang ingin di update
   * @param {object} data - Data yang ingin di update
   * @return {Promise} Promise yang berisi response dari server
   */
  updateBunkeringLog: async (id, bunkeringLogData) => {
    const { data } = await axiosInstance.put(`/master/bunker/log/${id}`, bunkeringLogData, {
      cancelToken: getNewCancelToken(),
    });
    return data;
  },
  /**
   * Menghapus data Bunkering Log yang sudah ada
   * @function deleteBunkeringLog
   * @param {number} id - ID dari Bunkering Log yang ingin di hapus
   * @return {Promise} Promise yang berisi response dari server
   */
  deleteBunkeringLog: async (id) => {
    const { data } = await axiosInstance.delete(`/master/bunker/log/${id}`, {
      cancelToken: getNewCancelToken(),
    });
    return data;
  },

  /**
   * Mendapatkan data Bunkering Log berdasarkan ID
   * @function getBunkeringLogDetailById
   * @param {number} id - ID dari Bunkering Log yang ingin di dapatkan
   * @return {Promise} Promise yang berisi response dari server
   */
  getBunkeringLogDetailById: async (id, params) => {
    const { data } = await axiosInstance.get(`/master/bunker/log/detail/${id}`, {
      params: { ...params },
      cancelToken: getNewCancelToken(),
    });
    return data;
  },

  /**
   * Membuat data Adjustment Bunker baru
   * @function createBunkerAdjustment
   * @param {object} adjustmentData - Data adjustment yang akan dibuat
   * @returns {Promise}
   */
  createBunkerAdjustment: async (adjustmentData) => {
    const { data } = await axiosInstance.post('/master/bunker/adjustment', adjustmentData, {
      cancelToken: getNewCancelToken(),
    });
    return data;
  },

  /**
   * Menghapus data adjustment bunker berdasarkan ID
   * @function deleteBunkerAdjustment
   * @param {number} id - ID dari adjustment bunker yang ingin di hapus
   * @return {Promise} Promise yang berisi response dari server
   */
  deleteBunkerAdjustment: async (id) => {
    const { data } = await axiosInstance.delete(`/master/bunker/adjustment/${id}`, {
      cancelToken: getNewCancelToken(),
    });
    return data;
  },

  /**
   * Mengedit data adjustment bunker berdasarkan ID
   * @function editBunkerAdjustment
   * @param {number} id - ID dari adjustment bunker yang ingin di edit
   * @param {object} adjustmentData - Data adjustment yang akan di edit
   * @return {Promise} Promise yang berisi response dari server
   */
  updateBunkerAdjustment: async (id, adjustmentData) => {
    const { data } = await axiosInstance.put(`/master/bunker/adjustment/${id}`, adjustmentData, {
      cancelToken: getNewCancelToken(),
    });
    return data;
  },
};
